import {useMemo} from 'react';
import type {ThesaurusAction} from 'types';
import type {SceneExtensionCore} from 'sceneExtensions/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import {ColorPalette} from 'theme';
import type {MultiThesaurusFieldConfig, MultiThesaurusValue} from '../types';
import {MultiThesaurusEditContainer} from '../MultiThesaurusEditContainer';
import {useMultiThesaurusFieldExtension} from './useMultiThesaurusFieldExtension';

export const useMultiThesaurusEditSceneExtensionCore = () => {
  const fieldExtension = useMultiThesaurusFieldExtension();

  return useMemo((): SceneExtensionCore<
    FieldExtensionEnum.multiThesaurusEdit,
    MultiThesaurusValue,
    MultiThesaurusValue,
    ThesaurusAction,
    MultiThesaurusFieldConfig
  > => {
    return {
      type: FieldExtensionEnum.multiThesaurusEdit,
      panelConfig: {
        backgroundColour: ColorPalette.enhancedBrown,
      },
      renderRightPanel: (onClose: () => Promise<void>) => (
        <MultiThesaurusEditContainer onClose={onClose} />
      ),
      fieldContext: fieldExtension,
    };
  }, [fieldExtension]);
};
